module.exports = __webpack_public_path__ + "img/liaojiegengduo.6adfa408.png";